import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import AIAgentsModule from './components/AIAgentsModule';
import LeadRepository from './components/LeadRepository';
import AuditTracking from './components/AuditTracking';
import TeamManagement from './components/TeamManagement';
import ConnectedApps from './components/ConnectedApps';
import AMLMonitoring from './components/AMLMonitoring';
import RBICMSITFramework from './components/RBICMSITFramework';
import FIUVDASPs from './components/FIUVDASPs';
import AuditFortress from './components/AuditFortress';
import DPDPReadiness from './components/DPDPReadiness';
import FRMGuardrail from './components/FRMGuardrail';
import RuleCockpit from './components/RuleCockpit';
import AIOrchestration from './components/AIOrchestration';
import LegalTechHub from './components/LegalTechHub';
import ConsultancyHub from './components/ConsultancyHub';
import FinanceModule from './components/FinanceModule';
import StrategicIntelligence from './components/StrategicIntelligence';
import LeadGenerationHub from './components/LeadGenerationHub';
import KnowledgeHub from './components/KnowledgeHub';
import ContractsHub from './components/ContractsHub';
import AskSanjeevWidget from './components/AskSanjeevWidget';
import PlaceholderPage from './components/PlaceholderPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="flex h-screen overflow-hidden">
          <Sidebar />
          <Routes>
            <Route path="/" element={<Dashboard />} />

            {/* Regulatory frameworks */}
            <Route path="/rbi-cms-it" element={<RBICMSITFramework />} />
            <Route path="/fiu-vdasps" element={<FIUVDASPs />} />
            <Route path="/dpdp-readiness" element={<DPDPReadiness />} />
            <Route path="/i4c-cims" element={<PlaceholderPage title="I4C CIMS Integration" />} />
            <Route path="/rule-cockpit" element={<RuleCockpit />} />

            {/* AI & FRM */}
            <Route path="/ai-orchestration" element={<AIOrchestration />} />
            <Route path="/aml-monitoring" element={<AMLMonitoring />} />
            <Route path="/frm-guardrail" element={<FRMGuardrail />} />

            {/* Solutions */}
            <Route path="/audit-fortress" element={<AuditFortress />} />
            <Route path="/legal-tech" element={<LegalTechHub />} />
            <Route path="/finance" element={<FinanceModule />} />
            <Route path="/consultancy-hub" element={<ConsultancyHub />} />
            <Route path="/strategic-intelligence" element={<StrategicIntelligence />} />
            <Route path="/lead-hub" element={<LeadGenerationHub />} />
            <Route path="/knowledge-hub" element={<KnowledgeHub />} />
            <Route path="/contracts-hub" element={<ContractsHub />} />

            {/* Operations */}
            <Route path="/agents" element={<AIAgentsModule />} />
            <Route path="/connected-apps" element={<ConnectedApps />} />
            <Route path="/leads" element={<LeadRepository />} />
            <Route path="/audits" element={<AuditTracking />} />
            <Route path="/team" element={<TeamManagement />} />
            <Route path="/news" element={<PlaceholderPage title="Regulatory News" />} />
            <Route path="/settings" element={<PlaceholderPage title="Settings" />} />
          </Routes>
          <AskSanjeevWidget />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
